import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ASSET_INFO_HEADINGDS, ROUTES } from '@common/interfaces';
import { Store } from '@ngrx/store';

import { getAssetCounts } from 'libs/common/src/lib/constants/shared-common';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { reset } from 'store/search-state/search.action';
import { ISearchState } from 'store/search-state/search.state';

@Component({
  selector: 'app-asset-info',
  templateUrl: './asset-info.component.html',
  styleUrls: ['./asset-info.component.scss'],
  animations: [
    trigger('basicAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AssetInfoComponent implements OnInit {
  @Input() assets!: any;
  @Input() displayDashboardContainer!: boolean;
  @Input() title: string = '';
  @Input() isDashboard!: boolean;
  @Input() isAssetTypeCounter: boolean = false;
  @Input() hasAddAsset = false;
  @Input() hasEditAsset = false;
  @Output() addAssetClicked = new EventEmitter();
  @Output() createWorkspaceClicked = new EventEmitter();
  @Output() editAssetClicked = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  @Input() buttonText!: string;
  @Input() titleForClientDropDown!: string;
  @Input() reportType!: string;
  @Output() workspaceStatus = new EventEmitter();
  type!: string;
  status!: string;
  ticketType!: string;
  queryParams!: any;
  formTitle = 'Add Asset'
  displayedColumns: string[] =  [
    'assets',
    'assigned',
    'unAssigned',
    'outForRepair',
    'inHouseRepair',
    'disabled'
  ]

  displayedColumnsCount: any = {
    totalByTypeAssets: 0,
    allocatedAssets: 0,
    availableAssets: 0,
    outForRepairAssets: 0,
    inHouseRepairAssets: 0,
    disabledAssets: 0,
  };
  isDisabled = false;
  dataSource!: any;
  loaderView: boolean = false;
  showButton: boolean = true;
  currentParam!: string;
  isUser!: boolean;
  isAdmin!: boolean;
  isSemiAdmin!: boolean;
  isEkoAdmin!: boolean;
  showWorkSpace!: boolean;
  isDownloadReportButtonDisabled: BehaviorSubject<{
    from: string;
    flag: boolean;
  }> = this.commonService.makeDownloadReportButtonDisabled;

  @ViewChild('table') table!: ElementRef;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private commonHttpService: CommonHttpService,
    private store: Store<ISearchState>
  ) {}

  ngOnInit(): void {
    this.isUser =
      JSON.parse(localStorage.getItem('userInfo') || '{}')?.roles[0] ===
      'USER';
    this.activatedRoute.queryParams.subscribe((param) => {
      this.currentParam = param['provider'];
      this.isDisabled =
        this.currentParam === 'EKO CLIENT' ? !this.isDisabled : false;
    });
    this.getCurrentMenu();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.status = params['status'];
      this.getCurrentMenu();
    });
    this.getAssetCountMetrics();
    if (this.title === ASSET_INFO_HEADINGDS.TICKET_STATUS) {
      this.buttonText = `Download Ticket List`;
    }
    if (this.title === ASSET_INFO_HEADINGDS.ASSET_STATUS) {
      this.buttonText = `Download Asset List`;
    }
    if (this.title === ASSET_INFO_HEADINGDS.APPROVAL_STATUS) {
      this.buttonText = `Download Approval List`;
    }

    if (this.router.url === ROUTES.ASSET_TEAM_DASHBOARD + '/coditas') {
      this.showButton = false;
    }
    const isManageWorkspaceWithQueryParams =
      this.router.url.startsWith(ROUTES.SUPER_ADMIN_DASHBOARD) &&
      this.router.url.includes('?size=5&column=WORKSPACE_NAME');

    if (
      this.router.url === `${ROUTES.SUPER_ADMIN_DASHBOARD}/dashboard` ||
      isManageWorkspaceWithQueryParams
    ) {
      this.showButton = false;
      this.showWorkSpace = true;
    }

  }

  getAssetCountMetrics() {
    this.loaderView = true;
    const loadRequest = this.commonHttpService.getAllAssetTypeCounts();
    
    if (!loadRequest) return;

    
    loadRequest.subscribe({
      next: (response: any) => {
        const formattedResponse = Object(response).data;
        const isAccessoriesReport = this.reportType === "Accessories Status";

        this.dataSource = isAccessoriesReport ? formattedResponse.accessoriesCount : formattedResponse.assetsCount;
        const statusData = isAccessoriesReport ? formattedResponse.accessoriesTotalByStatus : formattedResponse.assetsTotalByStatus;
        
        Object.keys(this.displayedColumnsCount).forEach((key) => {
          const statusKey = key.replace("Assets", ""); 
          this.displayedColumnsCount[key] = statusData[statusKey] ?? 0; 
        });
  
        this.loaderView = false;
      },
      error: () => {
        this.loaderView = false;
        this.dataSource = [];
      },
    });
    
  }

  

  setAssetPageParam(param: string) {
    this.workspaceStatus.emit(param);
    this.store.dispatch(reset());
    this.commonService.assetsPageParam = param;
    if (this.router.url !== '/home/asset-team-dashboard/coditas') {
        const queryParams = { status: param };
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: queryParams,
        });
    }
  }
  getCurrentMenu() {
    if (this.router.url.includes('ticket')) {
      this.type = 'ticket';
    } else if (this.router.url.includes('assets')) this.type = 'assets';
  }

  addAssetModal(event: any) {
    this.addAssetClicked.emit(true);
  }
  CreateWorkspaceModal(event: Event) {
    this.createWorkspaceClicked.emit(true);
  }
  onDownload() {
    this.buttonClick.emit();
  }

  handleAssetClick(value: string) {
    const selectedAsset = value === 'Mobile Phone' ? 'Mobile' : value;
    this.commonService.filterAssetByAssetName(selectedAsset);
    const queryParams = { assetType: selectedAsset };
    this.router.navigate([ROUTES.ADMIN_INVENTORY], { queryParams });
  }

  isDownloadButtonDisabled(): boolean {
    const shouldDisable =
      this.title === this.isDownloadReportButtonDisabled.getValue().from
        ? this.isDownloadReportButtonDisabled.getValue().flag
        : false;
    return shouldDisable;
  }

  getOption(option: string) {
    this.reportType = option;
    this.dataSource = [];
    this.getAssetCountMetrics()
  }

  getAddStatus(selectedOption: string){
    if (selectedOption === 'Add Asset') {
    this.router.navigate([`${ROUTES.ADD_ASSET}`]);
  } else if (selectedOption === 'Add Accessory') {
    this.router.navigate([`${ROUTES.ADD_ACCESSORY}`]);
  }
    this.addAssetModal('');
  }

  getValidImageUrl(icon: any, defaultIcon: string): string {
    return  typeof icon === 'string' ? icon : defaultIcon;
  }
  
}
